(function (module) {
    "use strict";

    module.service('chamferingSkuCalculationService', ['synchronousEventsBus',
        function(this: $TSFixMe, synchronousEventsBus: $TSFixMe) {
            var service = this;

            service.registerEvents = function () {
                synchronousEventsBus.$on('chamferingSkuVolumePmForecastChanged', (e: $TSFixMe, args: $TSFixMe) => service.skuPriceChanged(args.parameters, null, args.forecast));
                synchronousEventsBus.$on('chamferingBrandVolumeForecastChanged', (e: $TSFixMe, args: $TSFixMe) => service.calculateSkuSplit(args.parameters, args.brand));
            }

            service.skuPriceChanged = (parameters: $TSFixMe, brand: $TSFixMe, skuForecast: $TSFixMe) => {
                
                var forecastLength = Math.floor(moment.utc(parameters.forecastEndDate).diff(moment.utc(parameters.forecastStartDate), 'months')) + 1;


                if (angular.isUndefinedOrNull(skuForecast.value.statisticalForecast) || angular.isUndefinedOrNull(skuForecast.value.pmForecast)) {
                    skuForecast.value = {
                        statisticalForecast: [],
                        pmForecast: []
                    };
                }

                for (let i = 0; i < forecastLength; i++) {
                    skuForecast.value.statisticalForecast[i] = skuForecast.volume.statisticalForecast[i] * skuForecast.price[i];
                    skuForecast.value.pmForecast[i] = skuForecast.volume.pmForecast[i] * skuForecast.price[i];
                }
                return synchronousEventsBus.$broadcast('chamferingSkuValuePmForecastChanged', { parameters, forecast: skuForecast });
            }

            service.calculateSkuSplit = (parameters: $TSFixMe, brand: $TSFixMe) => {
                
                var forecastLength = Math.floor(moment.utc(parameters.forecastEndDate).diff(moment.utc(parameters.forecastStartDate), 'months')) + 1;

                for (const sku of brand.skus) {
                    if (!sku.forecast.brandShr) {
                        sku.forecast.brandShr = [];
                    }

                    for (let i = 0; i < forecastLength; i++) {

                        const value = angular._get(sku, `forecast.volume.pmForecast[${i}]`, 0) / brand.forecast.volume.pmForecast[i];
                        sku.forecast.brandShr[i] = isNaN(value) ? 0 : value;
                    }
                }
            }
        }]);

    module.run(['chamferingSkuCalculationService', function (service: $TSFixMe) {
        service.registerEvents();
    }]);


})(angular.module('topline.services'));